import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  USER_REQUEST_MUTATION,
  UPDATE_OTP_COUNT_MUTATION,
  UPDATE_USER_ORDERS_MUTATION,
  UPDATE_USER_ADVISORY_MUTATION,
  UPDATE_PROFILE_MUTATION,
  RESET_ORDERS_MUTATION,
  UPDATE_ACTIVITY_RESERVECARINSU_MUTATION, 
  UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION
   //2022/01/13 Wen Add
} from './constants';

const userRequestMutation = (state, bool) => {
  state.loading = bool;
};

// after signup success & auto-login will invoke loginSuccess 
const loginSuccess = (state, payload) => {
  const { hasErrTransaction, ip } = payload;
  state.isLogin = true;
  state.ip = ip;
  state.hasErrTransaction = hasErrTransaction;
};

const logoutSuccess = (state) => {
  state.isLogin = false;
  state.hasErrTransaction = false;
  state.orders = null;
  state.advisorys = null;
  state.ip = null;
};

const updateProfile = (state, profile) => {
  state.profile = profile;
};

const updateOtpcount = (state, count) => {
  state.otp.restOfCount = count;
};

const updateUserOrders = (state, orders) => {
  state.orders = [...orders];
};

const updateAdvisorys = (state, advisorys) => {
  state.advisorys = advisorys;
};

const resetUserOrders = (state) => {
  state.orders = null;
  state.advisorys = null;
};

//updateActivityStatus
const updateActivityReserveCarInsu = ( state, activityData ) => {
  if(!activityData) {
    state.nowActivity.name = null;
  }else {
    const { name } = activityData;
    state.nowActivity.name = name;
 }
}

const updateActivityReservePetInsu = ( state, activityData ) => {
  //console.log(JSON.stringify( activityData));
  if(!activityData) {
    state.nowActivity.name = null;
  }else {
    const { name } = activityData;
    state.nowActivity.name = name;
 }
}
export default {
  [USER_REQUEST_MUTATION]: userRequestMutation,
  [LOGIN_SUCCESS]: loginSuccess,
  [LOGOUT_SUCCESS]: logoutSuccess,
  [UPDATE_PROFILE_MUTATION]: updateProfile,
  [UPDATE_OTP_COUNT_MUTATION]: updateOtpcount,
  [UPDATE_USER_ORDERS_MUTATION]: updateUserOrders,
  [UPDATE_USER_ADVISORY_MUTATION]: updateAdvisorys,
  [RESET_ORDERS_MUTATION]: resetUserOrders,
  [UPDATE_ACTIVITY_RESERVECARINSU_MUTATION]: updateActivityReserveCarInsu,
  [UPDATE_ACTIVITY_RESERVEPETINSU_MUTATION]:updateActivityReservePetInsu  //2022/01/13 Wen Add
};